import { Outlet } from "react-router";
import Sidebar from "../components/sidebar";
import PageTransition from "../components/page-transition";
import { NavigationGuardProvider } from "../contexts/navigation-guard-context";
import OnboardingChecklist from "../modules/onboarding/components/onboarding-checklist";

export default function LayoutMain() {
	return (
		<NavigationGuardProvider>
			<div className="flex h-screen">
				<Sidebar />
				<main className="relative flex-1 overflow-auto bg-[#fafafa]">
					<OnboardingChecklist />
					<PageTransition>
						<Outlet />
					</PageTransition>
				</main>
			</div>
		</NavigationGuardProvider>
	);
}
